<template>
    <div>
        <SidebarBase :theme="theme">
            <template #primary>
                <SidebarNavItem
                    label="Home"
                    :naked="true"
                    path="/"
                    icon="home"
                />
                <SidebarNavParent
                    label="Learn"
                    colors="bg-gradient-to-tr from-blue-500 to-blue-400"
                    icon="booklight"
                    path="/learn"
                    noChildren="true"
                >
                </SidebarNavParent>
                <SidebarNavParent
                    v-if="prep2Enabled"
                    label="Prep Beta 2.0"
                    colors="bg-gradient-to-tr from-blue-500 to-blue-400"
                    icon="sparkles"
                    :path="getPrep2Url"
                    no-children="true"
                >
                </SidebarNavParent>
                <SidebarNavParent
                    v-if="user.role === 'learner'"
                    :label="legacyPrepLabel"
                    colors="bg-gradient-to-tr from-blue-500 to-blue-400"
                    icon="summit"
                    path="/prep/exams"
                    no-children="true"
                >
                </SidebarNavParent>
                <SidebarNavParent
                    v-else
                    :label="legacyPrepLabel"
                    colors="bg-gradient-to-tr from-blue-500 to-blue-400"
                    icon="summit"
                    path="/prep/exams"
                >
                    <SidebarNavChild
                        label="Assignments"
                        icon="checklist"
                        path="/prep/assignments"
                    />
                    <SidebarNavChild
                        label="Exam Library"
                        icon="bookshelf"
                        path="/prep/exam-library"
                    />
                </SidebarNavParent>
                <SidebarNavParent
                    v-if="user.permissions.pulse && user.role === 'learner'"
                    label="Reporting"
                    colors="bg-gradient-to-tr from-blue-500 to-blue-400"
                    icon="pulse"
                    :path="getPulseStudentReportingUrl"
                    no-children="true"
                >
                </SidebarNavParent>
                <SidebarNavParent
                    v-if="user.permissions.pulse && user.role !== 'learner'"
                    label="Reporting"
                    colors="bg-gradient-to-tr from-blue-500 to-blue-400"
                    icon="pulse"
                    :path="getPulseLearnUrl"
                >
                    <SidebarNavChild
                        v-if="isManager"
                        label="Learn Reporting"
                        icon="booklight"
                        :path="getPulseLearnUrl"
                    />
                    <SidebarNavChild
                        label="Prep Reporting"
                        icon="summit"
                        :path="getPulsePrepUrl"
                    />
                </SidebarNavParent>
                <SidebarNavParent
                    v-if="false"
                    label="Bookmarks"
                    colors="bg-gradient-to-tr from-blue-500 to-blue-400"
                    icon="bookmark"
                    path="/learn/bookmarks"
                    noChildren="true"
                ></SidebarNavParent>
            </template>
            <template #secondary>
                <SidebarNavItem
                    v-if="user.permissions.admin"
                    label="Admin"
                    :naked="true"
                    icon="crown"
                    path="/admin"
                />
            </template>
        </SidebarBase>
    </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import { getEnv } from "@/env";
export default {
    props: {
        theme: String,
        impersonating: Boolean,
        features: Object,
    },
    computed: {
        ...mapState(["user"]),
        isManager() {
            const roles = [
                "admin",
                "admin-view-client-reports",
                "panorama-admin",
                "partner-owner",
                "partner-admin",
                "group-owner",
                "group-admin",
            ];
            // if user.role is in roles
            return roles.includes(this.user.role);
        },
        getPulsePrepUrl() {
            return `${getEnv('VITE_PULSE_APP_URL')}/prep`;
        },
        getPulseStudentReportingUrl() {
            return `${getEnv('VITE_PULSE_APP_URL')}/student/prep`;
        },
        getPulseLearnUrl() {
            return `${getEnv('VITE_PULSE_APP_URL')}/learn/courses`;
        },
        prep2Enabled() {
            return this.features?.prep2Navigation === true;
        },
        /**
         * "(Legacy)" only means something next to a visible Prep 2.0 entry —
         * users without the flag see one Prep, so it stays unqualified.
         */
        legacyPrepLabel() {
            return this.prep2Enabled ? "Prep (Legacy)" : "Prep";
        },
        getPrep2Url() {
            return getEnv('VITE_PREP2_APP_URL');
        },
    },
};
</script>
